/**
 * This is the image Lazy-loader service
 */

const $lazy = [ function () {
    this.run = function() {
        let images = Array.prototype.slice.call( document.querySelectorAll("img, picture"));

        if ("IntersectionObserver" in window ) {
            let lazyImageObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio > 0) {
                        let lazyImage = entry.target;
                        // console.log(entry.target.tagName);
                        if ( entry.target.tagName.toLowerCase() === 'picture') {
                            [].forEach.call(entry.target.children, function (child) {
                                child.addEventListener('error', function () {
                                    // console.log(child.src || child.srcset);
                                });
                                // console.log(child);
                                if ( child.dataset.hasOwnProperty('src')) {
                                    child.src = child.dataset.src;
                                    delete child.dataset.src;
                                }
                                if ( child.dataset.hasOwnProperty('srcset')) {
                                    child.srcset = child.dataset.srcset;
                                    delete child.dataset.src;
                                }
                            });
                        }

                        if ( entry.target.tagName.toLowerCase() === 'img' && entry.target.parentNode.tagName.toLowerCase() !== 'picture') {
                            if ( lazyImage.dataset.hasOwnProperty('src')) {
                                lazyImage.src = lazyImage.dataset.src;
                                delete lazyImage.dataset.src;
                            }
                        }
                        //
                        // if ( lazyImage.dataset.hasOwnProperty('src')) {
                        //     lazyImage.src = lazyImage.dataset.src;
                        //     delete lazyImage.dataset.src;
                        // }
                        // if ( lazyImage.dataset.hasOwnProperty('srcset')) {
                        //     lazyImage.srcset = lazyImage.dataset.srcset;
                        //     delete lazyImage.dataset.src;
                        // }
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });

            images.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });

            return true;
        }

        // Old browsers fallback
        for ( let key in images ) {
            if ( images.hasOwnProperty(key) === true ) {
                if ( images[key].dataset.hasOwnProperty('src')) {
                    images[key].src =  images[key].dataset.src;
                    delete  images[key].dataset.src;
                }
                if ( images[key].dataset.hasOwnProperty('srcset')) {
                    images[key].srcset =  images[key].dataset.srcset;
                    delete  images[key].dataset.src;
                }
            }
        }
    }
}];

export default $lazy;
